import GameStreak from "../components/GameStreak";

const BottomRight = ({ gameData }) => {
  if (!gameData) return null;

  return (
    <div className="text-white">
      <GameStreak gameStatistics={gameData.GameStreakAwayTeam} team={gameData.AwayTeam} logoOnRightSide />
    </div>
  );
};

export default BottomRight;
